import { render, staticRenderFns } from "./chooseProductSpec.vue?vue&type=template&id=12999330"
import script from "./chooseProductSpec.vue?vue&type=script&lang=js"
export * from "./chooseProductSpec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports